/**
 * AI 生文
 * @returns
 */
import { Box, Flex } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import WritingLeft from "@/components/writingComponent/writingLeft";

const Writing = () => {
  return (
    <Box bgColor={"#fff"} h="calc(100vh - 61px)" overflow={"hidden"}>
      <Flex h="100%" boxSizing="border-box">
        <Box>
          <WritingLeft />
        </Box>
        <Box
          flex={1}
          w="0"
          h="100%"
          // maxW={"1034px"}
          m="0 auto"
        >
          <Outlet />
        </Box>
      </Flex>
    </Box>
  );
};

export default Writing;
